<template>
  <div class="notice-box" :class="boxClassName">
    <i class="notice-box-icon" :class="iconClassName" />
    <p class="text-paragraph">
      <slot></slot>
    </p>
  </div>
</template>

<script>
const TYPES = ['info', 'error']

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return TYPES.includes(value)
      }
    },
    borderless: {
      type: Boolean,
      required: false,
      default: false
    },
    iconClass: {
      type: [Array, String],
      required: false,
    }
  },
  computed: {
    boxClassName() {
      const classNames = [`is-${this.type}`]

      if (this.borderless) {
        classNames.push('is-borderless')
      }

      return classNames
    },
    iconClassName() {
      if (this.iconClass) {
        return Array.isArray(this.iciconClasson)
          ? this.iconClass
          : [this.iconClass]
      }

      switch (this.type) {
        case 'info':
          return ['fas', 'fa-check-circle']
        case 'error':
          return ['fas', 'fa-exclamation-circle']
        default:
          return ''
      }
    }
  }
}
</script>
